import React from 'react'
import styled from 'styled-components'
import { NavLink, Link, useLocation } from 'react-router-dom'
import { getStringWithUpperFirstChar } from '../../../functions/getStringWithUpperFirstChar'
import { colors } from '../../../styles/colors'

const Container = styled.div`
    padding: 6.25rem 0;

    @media(max-width: 767.98px) {
        display: none;
    }

    a, span {
        font-family: 'Lato', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 120%;
        letter-spacing: 0.05em;
        text-decoration: none;
        color: ${colors.dark_blue};

        @media(max-width: 960px) {
            font-size: 2.25rem;
        }
    }

    a {
        margin: 0 1rem;
        :hover {
            color: ${colors.red}
        }
    }

    .link-active {
        color: ${colors.red};
    }
`

export const BreadCrambs = () => {

    const location_path = useLocation().pathname;
    const pathes_arr = getArrayOfPathesForBreadcrumbs(location_path);    

    return (
        <Container>
            <Link to='/'> Главная</Link>
            <span>/</span>
            <NavLink activeClassName='link-active' exact to='/products'> Продукция</NavLink>
            { pathes_arr.map( (path_item, i )=> {

                let path = ''
                const new_path = pathes_arr.slice(0, ++i)
                new_path.forEach( p => {
                    path += ('/' + p)
                })               
            
                return (
                    <span key={i}>
                        <span>/</span>
                        <NavLink exact activeClassName='link-active' to={`/products${path}`} > { getStringWithUpperFirstChar(path_item) } </NavLink>
                    </span>
                )})
            }
        </Container>
    )
}

function getArrayOfPathesForBreadcrumbs (path) {
    const array_of_pathes_step_0 = path.split('/')
    const array_for_return = array_of_pathes_step_0.slice(2, array_of_pathes_step_0.length)    
    return array_for_return
}